import { Reason } from '@ilteducation/customer-mgmt-permissions';

/**
 * `mfa_required` is the only denial the caller can lift on their own, by escalating
 * the current session to a secure (MFA) login. Every other reason needs a different
 * caller, a different target or a configuration change.
 */
export const isFixableByEscalatedLogin = (reason: Reason | undefined): boolean => reason === 'mfa_required';
